import React from 'react';
export const content = (
  <React.Fragment>
    <p>
      Setting up your puppy’s first veterinary visit early can help you lay the groundwork for a
      healthy start to their life. Your veterinary will help you set up a vaccination schedule, a
      flea and tick prevention plan, and handle any lingering questions or concerns you may have
      about your puppy’s health.
    </p>
    <p>
      As a veterinarian, we want to see your puppy thrive just as much as you do, so never hesitate
      to reach out with questions. Below you will find some quick tips and insights around puppy
      health and grooming that we find helpful for new puppy parents.
    </p>
  </React.Fragment>
);
